import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const MCubeCall = (data) => {
    return axios({
        method: "post",
        url: BASE_URL + "/fseva-lead/api/secure/v1/mcube-outbound",
        headers: getHeaders(),
        data: JSON.stringify(data),
    });
};